import axios from 'axios';
import headers from "./Header";
let url = '/recommendation'
class RekomendasiService {
    getData(id) {
        return axios.get(url + '/' + id, {
            headers: headers(),
        })
    }
}

export default new RekomendasiService();